<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">
          Customer Profile:
          <b>{{ $route.query.name ? $route.query.name : "" }}</b>
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-tabs color="primary" v-model="tabSeleted" slider-color="primary">
        <v-tab
          v-for="item in items"
          :key="item.key"
          :href="'#' + item.key"
          color="white"
          class="text-capitalize text-decoration-none"
        >
          {{ item.label }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabSeleted">
        <v-tab-item id="profile-vue">
          <UserProfile @profileData="profileData" @profileInfo="profileInfo" />
          <KYC />
        </v-tab-item>
        <v-tab-item id="authorization">
          <v-card class="mt-2">
            <BusAuthorization />
          </v-card>
        </v-tab-item>
        <v-tab-item id="beneficiary-list-vue">
          <beneficiaryListVue />
        </v-tab-item>

        <v-tab-item id="compliance-Sanction">
          <CompilanceSanctionListVue :custprofileData="custprofileData" />
        </v-tab-item>
        <v-tab-item id="compliance-limitation-vue">
          <complianceLimitationVue :selectedRemitee="selectedRemitee" />
        </v-tab-item>
        <v-tab-item id="transaction-history-vue">
          <transactionHistoryVue :selectedRemitee="$route.query.id" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
import KYC from "./tabs/KYC/index.vue";
import UserProfile from "./tabs/Profile/index.vue";
import BusAuthorization from "./tabs/BusinessTabs/BusAuthorization.vue";
import beneficiaryListVue from "./tabs/beneficiary-list.vue";
import complianceLimitationVue from "./tabs/compliance-limitation.vue";
import transactionHistoryVue from "./tabs/transaction-history.vue";
import CompilanceSanctionListVue from "./tabs/CompilanceSanctionList.vue";
export default {
  name: "List-Overview",

  components: {
    UserProfile,
    KYC,
    beneficiaryListVue,
    complianceLimitationVue,
    transactionHistoryVue,
    CompilanceSanctionListVue,
    BusAuthorization,
  },
  mounted() {
    console.log("user_type", this.$route.query.user_type);
    this.selectedRemitee = this.$route.query.login_id;
    this.selectedType = this.$route.query.user_type;
    sessionStorage.setItem("benfiaryName", this.$route.query.name);
    console.log("route.query.id  " + JSON.stringify(this.$route.query.id));
    if (this.$route.query.user_type != "Business") {
      this.items.splice(1, 1);
    }
  },
  data: () => {
    return {
      tabSeleted: 0,
      custprofileData: {},
      items: [
        { label: "Profile", key: "profile-vue" },
        { label: "Authorization", key: "authorization" },
        { label: "Payout List", key: "beneficiary-list-vue" },
        { label: "Compliance Sanctions", key: "compliance-Sanction" },
        { label: "Balance History", key: "transaction-history-vue" },
      ],

      selectedRemitee: null,
    };
  },
  watch: {},
  created() {
    if (sessionStorage.getItem("prevPath") === "/benfTabs") {
      this.tabSeleted = "beneficiary-list-vue";
    }
    const tabIndex = parseInt(this.$route.params.tabIndex);
    if (!isNaN(tabIndex)) {
      this.tabSeleted = tabIndex;
    }
  },
  methods: {
    profileData(data) {
      this.custprofileData = data;
    },
    profileInfo(info) {
      this.custprofileData = info;
    },
  },
};
</script>
